import React from 'react';
import { downloadTemplate as downloadTemplateApi } from '../api/insuranceApi';
import { downloadBlob } from '../utils/fileUtils';
import { MESSAGES } from '../constants/messages';
import '../styles/ExcelStructurePreview.css';

const ExcelStructurePreview: React.FC = () => {
  const downloadTemplate = async () => {
    try {
      const blob = await downloadTemplateApi();
      downloadBlob(blob, 'insurance_template.xlsx');
    } catch (error) {
      console.error('Error downloading template:', error);
      alert(MESSAGES.ERROR_DOWNLOAD_TEMPLATE);
    }
  };

  return (
    <div className="excel-structure-preview">
      <div className="preview-header">
        <div className="preview-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
            <polyline points="13 2 13 9 20 9"/>
          </svg>
        </div>
        <div className="preview-header-content">
          <h3>Δομή Αρχείου Excel</h3>
          <p>Η μορφή που πρέπει να έχει το αρχείο σας</p>
        </div>
      </div>

      <div className="template-download-section">
        <button className="template-download-btn" onClick={downloadTemplate}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Κατέβασμα Προτύπου
        </button>
      </div>

      <div className="excel-preview">
        <table className="excel-table">
          <thead>
            <tr>
              <th className="col-label">A</th>
              <th className="col-header">ΑΦΜ</th>
              <th className="col-label">B</th>
              <th className="col-header">Αριθμός Κυκλοφορίας</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="row-num">1</td>
              <td className="data-value">123456789</td>
              <td className="row-num">1</td>
              <td className="data-value">ABC123</td>
            </tr>
            <tr>
              <td className="row-num">2</td>
              <td className="data-value">123456789</td>
              <td className="row-num">2</td>
              <td className="data-value">ΑΒΓ123</td>
            </tr>
            <tr>
              <td className="row-num">3</td>
              <td className="data-value">987654321</td>
              <td className="row-num">3</td>
              <td className="data-value">ΔΕΖ456</td>
            </tr>
            <tr className="empty-row">
              <td className="row-num">...</td>
              <td className="data-value empty">...</td>
              <td className="row-num">...</td>
              <td className="data-value empty">...</td>
            </tr>
          </tbody>
        </table>

        <div className="preview-info">
          <div className="info-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            <span>Στήλη A: ΑΦΜ (9-11 ψηφία)</span>
          </div>
          <div className="info-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            <span>Στήλη B: Αριθμός Κυκλοφορίας</span>
          </div>
          <div className="info-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            <span>Η πρώτη γραμμή μπορεί να είναι header (προαιρετικό)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExcelStructurePreview;

